import { useLoaderData, useNavigate } from "react-router-dom";
import { UpdateHistoryModal } from "./update-history-modal";

export function UpdateHistoryRoute() {
  const navigate = useNavigate();
  const { history, isLoading } = useLoaderData() as {
    history: any;
    isLoading: boolean;
  };

  return (
    <UpdateHistoryModal
      isOpen={true}
      onClose={() => navigate(-1)}
      history={history}
      isLoading={isLoading}
    />
  );
}
